import type { JSX, ReactNode } from "react";
import { Navigate } from "react-router-dom";
import { getUser } from "../lib/auth";
import { adminRedirect } from "./guard";

export function RequireAdmin({ children }: { children: ReactNode }): JSX.Element {
  const dest = adminRedirect(getUser());
  if (dest !== null) return <Navigate to={dest} replace />;
  return <>{children}</>;
}
